<template>
  <div  class="contentdetail">
    <button v-on:click="backHistory" class="btn">返回</button>
    <div class="title text-center">{{article.title}}</div>
    <div class="author text-center margin-top-10 margin-bottom-20">作者:<span  class="margin-left-small margin-right-10">{{article.author}}</span> <i class="iconfont icon-yanjing1"></i><span class="margin-left-small margin-right-20">阅读数：{{article.readNum}}</span><span>{{article.publishTime}}</span></div>
    <div class="text-center">
      <!-- <img src="../../../../static/images/ditu.png" class="img-max text-center margin-top-10 margin-bottom-20"  style="max-width:100%;border:1px solid #efefef;"/> -->
    </div>
    <div class="desc" v-html="article.content"></div>
    <ul>
      <li v-for="(item,index) in list " :key="index">{{item.id}}</li>
    </ul>
  </div>

</template>

<script>
export default {
  name: 'DetailList',
  props: {
    list: Array,
    article: Object
  },
  components: {
  },
  mounted () {
  },
  methods: {
    backHistory () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .title{
    font-size:24px;
  }
  .author{
    font-size:13px;
    color:#999;
  }
  .desc{
    line-height:30px;
    color:$fontGray;
    text-indent: 2em;
  }
  .btn{
    width:80px;
    height:30px;
    margin-bottom: 30px;
    line-height:30px;
    border-radius:15px;
    text-align:center;
    background:$bgColor;
    border:1px solid $bgColor;
    color:#fff;
    padding:0;
  }
  .contentdetail{
    margin-bottom:20px;
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/detail/components/DetailList.vue